module.exports = __webpack_public_path__ + "static/media/Item_Weapon_G18_C.2d1a2586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_G18_C.png
// module id = ./src/assets/item/Weapon/Handgun/Item_Weapon_G18_C.png
// module chunks = 0